import React from "react";
import { connect } from "react-redux";
import CustomPageLayout from "./CustomPageLayout";
import AdminMenu from "../administrace/lists/components/AdminMenu";
import TemplateList from "../administrace/lists/components/TemplateList";
/**
 * Stránka administrace, zobrazující menu po levé straně a obsah konkrétní stránky vpravo.
 */

class TemplatesPage extends React.Component {
  render() {
    return (
      <CustomPageLayout header headerButton={false} searchField={false} title="Šablony notifikací" menu={<AdminMenu />}>
        <TemplateList />
      </CustomPageLayout>
    );
  }
}

function mapStateToProps(state) {
  return state;
}

export default connect(mapStateToProps)(TemplatesPage);
